import { segmentTrack } from './useTracking';

type TerminalCommandType = 'cli' | 'curl';

type SurfaceParams =
  | {
      source: 'build_start_dialog';
      appSlug: string;
      isCliCommandAvailable: boolean;
    }
  | {
      source: 'new_ci_project_from_cli_page';
      hasOptionToCreatePrivateApps: boolean;
    };

type TerminalCommandCopiedParams = SurfaceParams & {
  commandType: TerminalCommandType;
};

export function trackTerminalCommandCopied({ commandType, ...surface }: TerminalCommandCopiedParams) {
  segmentTrack('Terminal Command Copied', {
    platform: 'website',
    source: surface.source,
    command_type: commandType,
    ...(surface.source === 'build_start_dialog'
      ? { app_slug: surface.appSlug, is_cli_command_available: surface.isCliCommandAvailable }
      : { has_option_to_create_private_apps: surface.hasOptionToCreatePrivateApps }),
  });
}
